module.exports = __webpack_public_path__ + "static/img/D9.b124a88d.jpg";